class BESSAppNewProjectEditorLocationManager extends BESSAppProjectEditorManagerBase {

    constructor(owner) {
        super(owner.editor);
        this.lookupInProgress = false;
        this.owner = owner;
        this.location = owner.location;
        this.location.node.find('.app-orig-value').html('<div class="app-map-location"></div>');

        this.lookupAddress = owner.lookupAddress;
        BESSApp.instance.requireGoogleMaps(function () {
            let mapNode = this.editor.node.find('.app-map-location');
            let location = this.getLocation();
            let map = BESSAppMapLocation.createMap(mapNode, location.lat, location.lng);
            if (this.lookupAddress.input != null) {
                this.lookupAddress.input.geocomplete({
                    'mapOptions': {
                        zoom: 14
                    },
                    'details': '#form-details',
                    'detailsAttribute': 'data-geo',
                    'map': this.theMap,
                    'location': this.getLocation(),
                    'country': 'AU'
                }).bind('geocode:result', this.onLookupAddress.bind(this));
            }
        }.bind(this));

        this.editor.projectInputs.postcode.addValidator(this.validatePostcode.bind(this));
    }

    onLookupAddress(event, result) {
        function get_address_component(type) {
            let component = _.find(result.address_components, function (a) {
                return a.types.includes(type);
            });
            return component === undefined ? null : component;
        }

        let state = get_address_component('administrative_area_level_1');
        if (state !== null) {
            if (!this.editor.projectInputs.state.matchValue(state.short_name)) {
                //invalidate project reason
                return;
            }
        }

        let streetNumber = get_address_component('street_number');
        let streetName = get_address_component('route');
        let suburb = get_address_component('locality');
        let council = get_address_component('administrative_area_level_2');

        let postcode = get_address_component('postal_code');

        let streetAddress = '';
        if (streetName !== null || streetNumber !== null) {
            streetAddress = (streetNumber === null ? '' : streetNumber.long_name + ' ') + (streetName === null ? '' : streetName.short_name);
            this.editor.projectInputs.streetAddress.setValue(streetAddress);
        }
        if (suburb !== null) {
            this.editor.projectInputs.suburb.setValue(suburb.long_name);
        }
        if (council !== null) {
            let councilName = this.standardiseMunicipality(council.short_name, 'City Council');
            if(!this.editor.projectInputs.council.matchValue(councilName)) {
                councilName = this.standardiseMunicipality(council.short_name, 'Shire Council');
                this.editor.projectInputs.council.matchValue(councilName)
            }
        }

        if (postcode !== null) {
            this.editor.projectInputs.postcode.setValue(postcode.short_name);
        }

        let gpsLocation = result.geometry.location;
        let lat = gpsLocation.lat();
        let lng = gpsLocation.lng();

        this.editor.projectInputs.gpsLatitude.setValue(lat);
        this.editor.projectInputs.gpsLongitude.setValue(lng);

        let mapNode = this.editor.node.find('.app-map-location');
        BESSAppMapLocation.updateMapLocation(mapNode, lat, lng);

        this.editor.projectInputs.map.setValue({'lat': lat, 'lng': lng});
        /*if (!this.editor.projectInputs.projectName.getValue()) {
            this.editor.projectInputs.projectName.setValue(streetAddress + ' ' + suburb.long_name);
        }*/
        this.owner.updateState();

        this.editor.projectInputs.projectName.focus();
    }

    validatePostcode(input, value) {
        let state = this.editor.projectInputs.state.getValue();
        if (state !== null) {
            let stateMinMax = this.editor.projectInputs.state.field.meta.validation[state.key];
            if (value !== null && value !== '') {
                value = parseInt(value);
                if (value < stateMinMax.min || value > stateMinMax.max) {
                    return "Invalid postcode for this state.";
                }
            }
        }
        return null;
    }


    getLocation = function () {
        let latVal = this.editor.projectInputs.gpsLatitude.getValue();
        let lngVal = this.editor.projectInputs.gpsLongitude.getValue();
        let lat = latVal || -37.814107,
            lng = lngVal || 144.963280;

        return {lat: lat, lng: lng};
    }
}